import { TbPlus } from "react-icons/tb";
import Tooltip from "../../../../../Components/Atoms/Tooltip";
import CreateOperatorModal from "../../../Operators/CreateOperatorModal";
import { OperatorsTableList } from "../../../Operators";
import React from "react";

type Props = {
  operators: any[];
  subAccountId?: string;
  onChanged?: () => void;
};

const OperadoresSection = ({ operators, subAccountId, onChanged }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [editingId, setEditingId] = React.useState<string | null>(null);

  return (
    <>
      <div className="mb-3 flex justify-end">
        <Tooltip title="Adicionar operador">
          <button
            type="button"
            className="btn-primary"
            onClick={() => {
              setEditingId(null);
              setOpen(true);
            }}
          >
            <TbPlus className="h-4 w-4" />
            Adicionar
          </button>
        </Tooltip>
      </div>

      <div className="app-card overflow-hidden">
        <OperatorsTableList
          operators={operators}
          isHiddenSubAccountLink
          onEdit={(id: string) => {
            setEditingId(id);
            setOpen(true);
          }}
        />
      </div>

      <CreateOperatorModal
        open={open}
        operatorId={editingId || undefined}
        onClose={() => {
          setOpen(false);
          setEditingId(null);
        }}
        onSaved={() => {
          onChanged?.();
          setOpen(false);
          setEditingId(null);
        }}
        defaultProfile="subAccount"
        defaultSubAccountId={subAccountId}
      />
    </>
  );
};

export default OperadoresSection;
